import { t } from "../../../translations";
import { validatePassword } from "./utils";

const PasswordRequirements = ({ password, selectedLang }) => {
  if (!password || password.length === 0) return null;

  const validation = validatePassword(password);

  return (
    <div style={{ margin: "10px", fontSize: "14px" }}>
      <p style={{ margin: "5px 0", fontWeight: "bold" }}>
        {t("navbar.password_requirements", selectedLang)}:
      </p>
      <div style={{ marginLeft: "10px" }}>
        <div
          style={{
            color: validation.requirements.minLength ? "green" : "red"
          }}
        >
          ✓ {t("navbar.password_req_min_length", selectedLang)}
        </div>
        <div
          style={{
            color: validation.requirements.hasUpperCase ? "green" : "red"
          }}
        >
          ✓ {t("navbar.password_req_uppercase", selectedLang)}
        </div>
        <div
          style={{
            color: validation.requirements.hasLowerCase ? "green" : "red"
          }}
        >
          ✓ {t("navbar.password_req_lowercase", selectedLang)}
        </div>
        <div
          style={{
            color: validation.requirements.hasNumbers ? "green" : "red"
          }}
        >
          ✓ {t("navbar.password_req_numbers", selectedLang)}
        </div>
        <div
          style={{
            color: validation.requirements.hasSpecialChar ? "green" : "red"
          }}
        >
          ✓ {t("navbar.password_req_special", selectedLang)}
        </div>
      </div>
    </div>
  );
};

export default PasswordRequirements;
